var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame155(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0837 13.248C1.0837 6.61777 6.45859 1.24288 13.0888 1.24288C19.7191 1.24288 25.094 6.61777 25.094 13.248C25.094 19.8783 19.7191 25.2532 13.0888 25.2532C6.45859 25.2532 1.0837 19.8783 1.0837 13.248Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.615648
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1677 18.4797H10.0112C8.16428 18.4797 6.93298 17.5562 6.93298 15.4015V11.0919C6.93298 8.93714 8.16428 8.01367 10.0112 8.01367H16.1677C18.0147 8.01367 19.2459 8.93714 19.2459 11.0919V15.4015C19.2459 17.5562 18.0147 18.4797 16.1677 18.4797Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.923472,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0894 15.0935C14.1095 15.0935 14.9364 14.2666 14.9364 13.2466C14.9364 12.2266 14.1095 11.3997 13.0894 11.3997C12.0694 11.3997 11.2425 12.2266 11.2425 13.2466C11.2425 14.2666 12.0694 15.0935 13.0894 15.0935Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.923472,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08771 11.7075V14.7858",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.923472,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0911 11.7075V14.7858",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.923472,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame155);
export default __webpack_public_path__ + "static/media/Frame 155.bbcfb28f2c3e583cb953464bfb846fb1.svg";
export { ForwardRef as ReactComponent };